export const ZhCN = {
  zhCN:{
    companyName: "KopaPro",
    langDesc: "简体中文",  
    en:"English", 
    zhTW:"繁",
    zhCN:"简",
    goodDay:"您好",
    home: "首页",
    kopapro:"KopaPro",
    addNewShop:"添加 KopaPro",
    addNewDomain: "购买新域名",
    refresh:"刷新",
    refreshFail:"刷新失败，请重试。",
    kopaproLicenses:"KopaPro 许可证",
    extend:"续期",
    change:"修改",
    renew: "重置",
    history:"历史纪录",
    subscriptionHistory:"订阅历史纪录",
    back:"后退",
    assign: "分配",
    sessionExpired:"页面已过期，请重新登录。",
    addNewMerchant:"添加新商户",
    pleaseWait:"请稍等",   
    loading:"载入中...", 
    needTrial:"需要免费试用吗?",
    subDirectly:"你亦能填写以下表格直接订阅",
    curd:{
      save:'保存',
      saveFail:'保存失败，请重试。',
      getFail:'获取数据失败，请重试。',
      saveSuccess:'保存成功！'
    },
    kopaproLicense:{   
      details:"详细",   
      client:"客户",   
      code:"KopaPro编号",
      codeHelperText:"独一无二的子域",
      desc: "店名",
      descHelperText:"商店名称",
      sysAdmin:"系统管理",
      rebranch:"重新初始化",
      rebranchKey:"重新初始化密码",
      plan:{
        plan:"方案",
        oriPlan:"目前方案",
        su: "基本",
        bu: "进阶",
        pm: "高级",
        et: "企业旗舰"
      },
      support:{
        support:"支援",
        oriSupport:"目前支持",
        noHotline:"电子邮件/Whatsapp",
        hotline:"电子邮件/Whatsapp/热线"
      },
      period:"周期",
      extendPeriod:"续约期数",
      years:"年",
      months:"月",
      currency:{
        currency:"货币",
        hkd:"港币",
        usd:"美元",
        sgd:"新加坡元",
        rmb:"人民币"
      },
      amt:"金额",
      couponCode:"优惠券码",
      discount:"优惠",
      netAmt:"净金额",
      expiryDate:"失效日期",
      newExpiryDate:"新失效日期",
      activationCode:"启动码 (M18 ERP 整合)",
      status:"状态",
      serverStatus:"服务器",
      createRemindMessage: '在选择付款方式后，你所偏好的KopaPro编号({0})会暂时保留，请在{1}分钟内完成付款程序。',
      paymentReason:{
        KPPPAY_EXTEND_SUBSCRIPTION:"KopaPro订阅续约",
        KPPPAY_UPDATE_PLANSUPPORT:"更改KopaPro订阅方案",
        KPPPAY_UPDATE_PLANSUPPORT_SU:"更改KopaPro计划为基本版",
        KPPPAY_UPDATE_PLANSUPPORT_BU:"更改KopaPro计划为进阶版",
        KPPPAY_UPDATE_PLANSUPPORT_PM:"更改KopaPro计划为高级版",
        KPPPAY_UPDATE_PLANSUPPORT_ET:"更改KopaPro计划为企业旗舰版",
        KPP_NEW_SUB:"订阅KopaPro",
        KPP_NEW_SUB_TRIAL:"免费试用",
        KPPPAY_UPDATE_SUPPORT_NOHOTLINE:'更改KopaPro支持为电子邮件 / Whatsapp',
        KPPPAY_UPDATE_SUPPORT_HOTLINE:'更改KopaPro支持为电子邮件, Whatsapp 及 热线',
        KPPPAY_UPDATE_MONTH:'更改KopaPro期数为',
        KPPPAY_UPDATE_YEAR:'更改KopaPro期数为',
        KPPPAY_UPDATE_CUR_HKD:'更改KopaPro订阅货币为港币',
        KPPPAY_UPDATE_CUR_USD:'更改KopaPro订阅货币为美元',
        KPPPAY_UPDATE_CUR_RMB:'更改KopaPro订阅货币为人民币',
        KPP_TRIAL_EXTEND:'KopaPro延长免费试用期'
      },
      residue:"方案余额",
      invalidRefCode: '优惠码无效',
      visit:"修改 eShop",
      payAndSubscribe:"订阅 & 支付",
      payAndExtend:"续期 & 支付",
      paid:"已支付",
      pending:"处理中",
      cancelled:"已取消",
      active:"生效",
      expired:"失效",
      running:"运行中",
      terminated:"终止运行",
      ended:"终止运行",
      finished:"已完成",
      pay:"支付",
      createDate:"建立日期",
      date:"日期",
      extendTrial:"延长免费试用期14日",
      accessFail:"存取KopaPro时发生错误，请联系KopaPro客户服务",                                             
      invalidCode:"无法存取所选的KopaPro，请重新选择",
      trialExpired:"你的免费试用已经完结",
      task:{
        Branch:"架设新服务器",
        Migrate:"搬迁数据到新服务器"
      },
      showServerTask:"检视服务器工作纪录",
      planChange:"你的方案将由 #oPlan# 改变成 #nPlan#" ,
      planChangeWarn1:"当你付款后，系统会进行数据迁移",
      planChangeWarn2: "根​​据你的KopaPro使用量，迁移所花的时间有可能达数小时",
      planChangeWarn3: "确认改变，请输入: ",      
      invalidPlanChange: "抱歉，KopaPro方案不能降级",
      refCode: "推广优惠码"      
    },
    dashboard: {
      title: "欢迎来到 KopaPro",
      missingInfo: {
        title: "完善你的帐户资料",
        notCompletedMsg: "你的帐户资料中尚有一些未填字段，这样可能会导致我们无法跟你取得联络。",
        notCompletedMsg2: "请到账户设定，并提供最新的基本资料及账单资料。",
        action: "编辑账户"
      },
      addTrial:{
        title: "马上试用",
        msg:"获得30天免费试用",
        msg2: "无须信用卡,免费试用KopaPro",
        action1: "免费试用",
        action2: "马上订阅你试用的KopaPro",
        action3: "开始配置你的商店"
      },
      trialPeriod: {
        title: "试用期尚余:",
        expireAt: "完结日期: "
      }
    },
    merchant:{
      basicInfo:"基础资料",
      secondAuth:"二次验证",
      billingInfo:"账单信息",
      merchant:"商户",
      email:"电子邮件",        
      firstName:"名字",
      lastName:"姓氏",
      name: "姓名",
      companyName:"公司名称",
      companyAddr:"公司地址",
      addr1:"地址第一行",
      addr2:"地址第二行",
      zipCode:"邮政编码",
      city:"城市",
      province:"省份",
      country: "国家",                
      areaCode: "区号",
      mobile: "手机号码",
      tel: "电话号码",
      compTel:"公司电话",
      progCode:"程序编号",
      billingInfoHint: '请提供此账户的账单信息' ,
      basicInfoHint: '请提供此账户的基础资料',
    },
    signUp:{
      title: "注册",
      password:"密码",
      confirmPw:"确认密码",
      successInfo:"注册成功",
      notMatchPassword: "与密码不相同"
    },
    domains: {
      title: "域名",
      domainName: '域名',
      createAt: '建立时间',
      expires: '失效日期',
      status: '状态',
      renewAuto: '自动更新',
      mappedKopaPro: "映射到 KopaPro",
      renewDeadline: '更新最后期限',
      renewable: '可更新',
      ownerEmail:"域名所有者电子邮件",   
      companyName:"公司名称",
      acceptAgreement: "我已阅读并同意 {0}",
      acceptAgreementLinkText: "域名注册协议",
      icannPrivacy:"ICANN 隐私条款",
      assignToKopapro: "分配到 {0} KopaPro",
      perYear: "/年",
      nextYearRenew:'下一次续费',
      perYearCharge:'每年: {0} {1}',
      domainContactLabel:'请提供此域名所需的信息',
      purchasePrivacy: " 购买 WHOIS 私隐保护",
      suggestion: "建议",
      otherSuggestion: "其他建议",
      available: '域名可被使用',
      notAvailable: '域名不可被使用',
      statuses: {
        InActive: "失效",
        Active: "生效",
        Suspended: "已停止",
        "Pending Delete Restorable": "等待删除复原",
        Deleted: "已删除",
        Archived: "已存档",
        "Pending Verification": "待认证",
        "Failed Verification": "认证失败",
        notAvailable: "不可使用",
        owned: "所有权归您",
        taken: "已被注册",
        notSupported: "不支持",
        processing: "处理中"
      },
      singleYear: "{0} 年",
      multiYears: "{0} 年",
      buyNew: {
        subTitle: "购买新域名",
        enterDomain: "输入您想要购买的域名.",
        selectDomain: "选择域名",
        provideInfo: "提供信息",
        payment: "付款",
      },
      payment: {
        title: "订单信息",
        domainOwnerInfo: "域名所有者信息",
        whoisPrivacy: "WHOIS 隐私保护",
        whoisDetail: "当你启动隐私保护服务时，我们会在公共注册纪录中以通用的联络信息替换你的个人信息，因此您的个人信息不会被显示在公共注册纪录。",
        privacy: "隐私&协议",
        agreementStatement: "请确认您已阅读并同意 {0}和{1}。"
      },
      errors: {
        "invalid_shop_license_code": "无效的店铺编号。",
        "invalid_tlds": "无效的顶级域名。",
        "fetch_fail": "没找到相关的域名，请输入其他关键字搜索。",
        invalidCharacters: "无效的字符。"
      },
      alerts: {
        expiry: {
          title: "域名满期提醒",
          message: "你的域名即将满期。请尽快处理以避免丢失域名。",
        },
        expired: {
          title: "域名失效提醒",
          message: "你的域名已经过期。请尽快处理以避免丢失域名。",
        },
        assignedDomain: {
          message: "你已分配 {0} 到 KopaPro - {1}. 发布KopaPro后，该域名立即生效。"
        }
      },
      contact: {
        englishOnly: "以下栏位必须以英文填写"
      },
      delayRecords: "如果你刚才购买的域名仍未显示在表中，请稍等并在几秒后刷新。"
    },
   
    general: {
      errors: {
        required: "此栏位必须填入",
        maxLength: "不能多于 {0} 字符",
        minLength: "不能少于 {0} 字符",
        phone: "无效的电话号码",
        email: "无效的电子邮件地址",
        currentPassword: "密码不正确",
        notMatchPassword: "与新密码不相同",
        requiredPassword: "如更改密码，此栏位必须填入",
        englishOnly: "此栏位只能以英文字符填写",
        alphanumericOnly: "此栏位只能以英文及数字字符填写",
        alphanumericSymbolOnly: "此栏位只能以英文﹑数字字符及特定符号填写(+-_&(),.:'`;/)",
        invalidEmailPassword: "电子邮件或密码不正确"
      },
      email:"电子邮件",   
      emailAddress:"电子邮件地址",   
      firstName:"名字",
      lastName:"姓氏",
      companyName:"公司名称",
      phoneNumber: "电话号码",
      addr1:"地址行1",
      addr2:"地址行2",
      postalCode:"邮政编码",
      city:"城市",
      state: "州 / 省份",
      province: " 州 / 省份",
      country: "国家/地区",
      noRecord: "没有纪录",
      exampleShort: "例:",
      cancel: "取消",
      confirm: "确定",
      back: "返回",
      next: "下一步",
      pay: "支付",
      save: "保存",
      signUp: "注册",
      signIn: "登入",
      select: "选择",
      search: "搜索",
      logout: "登出",
      total: '共',
      changePassword: "更改密码",
      account: "账户",
      password:"密码",
      currentPassword: "现有密码",
      newPassword: "新密码",
      confirmPassword: "重复新密码",
      haveAccount: "已有帐户？",
      noAccount:"没有帐户？",
      forgotPassword: "忘记密码？",
      forgotPasswordTitle: "忘记您的密码？",
      resetPasswordTitle: "重置密码",
      returnToLogin: "返回登入",
      loginFailed: "电子邮件地址或密码不正确",
      resetEmailSent:"已发送密码重设邮件，请检查你的电子邮箱。",
      resetSuccessFully:"密码已更新。",
      resetPwEmail:"请提供你登入时的电子邮件地址。",
      hasPendingPayment:"你有待付款项",
      trialCheckEmail:"请检查你的电邮信箱以获取试用的帐户信息",
      yes:"是",
      no:"否",
      verifyEmailTitle:"请认证你的电邮地址",
      verifyEmailMsg:"快要完成了!我们已传送电邮到",
      verifyEmailMsg2:"只需点击电邮内的链接即可完成注册",
      verifyEmailMsg3:"如果你找不到, 试试查看垃圾邮件箱",
      verifyEmailMsg4:"还是找不到电邮吗?",
      resendEmail:"重寄电邮",        
      backToSignUp:"返回登入",
      resendEmailOK:"成功重寄电邮",
      verifying:"请稍等认证中...",
      verifyOK:"成功认证",
      loginConsole:"登入KopaPro订阅平台",
      reloginKppSite: "请重新登入你的KopaPro以刷新失效日期"
    },
    footer: {
      contact: "联络",
      tos: "服务协议",
      privacyPolicy: "隐私权政策",
    },
    account: {
      title: "帐户信息"
    },
    KppResponse:{
      DUPCODE: "重复的账户",
      DUPSHOP: "商店已存在",
      NOTFOUND: "找不到数据",
      VALIDFAIL: "错误的字段",
      ILLEGAL_ALPHANUMERIC: "必须填写数字或小写字母",
      MAX_LENGTH:"超出字段长度上限",
      INVALID_INPUT_FORMAT:"错误的输入格式",
      TRIAL_CREATED:"你已申請過試用KopaPro",
      NO_DOWNGRADE:"方案不能降級",
      NO_DOWNPERIOD:"订阅周期不能减少",
      LOWERCASE:"栏位只能填写小写字母"
    },
    countdown: {
      days: "日",
      hours: "小时",
      mins: "分钟",
      secs: "秒",

    },
    payment: {
      title: "付款",
      instruction: "请扫描二维码以完成付款。",
      selectMethod: "选择付款方式",
        methods: {
          alipay: "支付宝",
          wechatPay: "微信支付",
          creditCard: "信用卡 / Apple Pay / Google Pay"
        }
    },
    wallet: {
      shortTitle: "MPCSB",
      title: '商户预付送件服务结余 (MPCSB)',
      overview: '总览',
      statement: '账单',
      transactions: 'Transactions',
      currentBalance: "当前结余",
      openingBalance: "期初结余",
      closingBalance: "期未结余",
      costIn7Days: '最近7天的送件下单费用',
      costIn30Days: '最近30天的下单费用',
      recentDeposit: '最近存入',
      depositDialogTitle: '存入',
        recentTransactions: '最近交易',
        date: '日期',
        description: '描述',
        type: '交易种类',
        types: {
          deposit: '存入',
          expense: '扣款',
        },
        amount : '金额',
        actions: {
          deposit: '存入',
          enable:'启动',
          accept: '同意及启动',
          getStatement: '预览账单',
          exportStatement: '下载账单(PDF)',
        },
        pending: '有待确认',
        walletStatement: 'MPCSB 账单',
        statementDate: '账单日期',
        topUp: '充值',
        use: '使用',
        dateTo: ' 至 ',
        balance: '结余',
        depositLabel: '请输入你想存入的金额:',
        enableDialogTitle: '启动服务',
        askEnableLabel: '启动以享用自动运单生成服务从而节省时间及减少错误。',
        currency: "货币",
        errors: {
          minAmount: "存入金额最少为 {0} {1}。",
          maxAmount: "存入金额最多为 {0} {1}。"
        },
        transactionDetails:{
          deposit: "存入至账户 ({0})",
          adjustment: "调整事项︰",
          reverseAdjustment: "反向调整事项︰",
        }



    }            

            
  }   
}


